<sh-page-header
  [title]="recordTitle$ | async"
  [contextItems]="recordContextItems$ | async"
  [actionItems]="recordActionItems$ | async"
  [primaryNavigationItems]="primaryNavigationItems"
  [secondaryNavigationItems]="secondaryNavigationItems"
></sh-page-header>

@if (notification) {
  <sh-notification
    [type]="notification.type"
    [icon]="notification.icon"
    [title]="notification.title"
    [message]="notification.message"
    [messageList]="notification.messageList"
  ></sh-notification>
}

@if ((record$ | async); as record) {
  @if (showIncompleteRepresentationNotification$ | async) {
    <sh-notification
      [icon]="'info'"
      [type]="NotificationType.Update"
      [message]="'representations.no-browse' | translate"
    ></sh-notification>
  }
  @if (showTransferredNotification$ | async) {
    <sh-notification
      [icon]="'info'"
      [type]="NotificationType.Update"
      [message]="'dossier-transfer.transferred-on' | translate : { date: record.metadata.Dynamic.DossierDefinitiveTransferDate | date: 'dd MMM yyyy'}"
    ></sh-notification>
  }
}

@if ((recordTabItems$ | async); as tabItems) {
  <nav class="sh-tab-navigation">
    @for (tabItem of tabItems; track tabItem) {
      <ng-container
        *ngTemplateOutlet="(shouldEnableNavigationItem(tabItem.route) | async) ? enabledNavigationItem : disabledNavigationItem; context: {tabItem: tabItem}"
      ></ng-container>
    }
  </nav>
}

<ng-template #enabledNavigationItem let-tabItem="tabItem">
  @if ((record$ | async); as currentRecord) {
    <a
      #rla="routerLinkActive"
      [routerLink]="tabItem.route"
      [state]="{ record: currentRecord }"
      class="sh-tab-navigation__item"
      routerLinkActive="-sh-is-active"
      [attr.aria-current]="rla.isActive ? 'location' : null"
      >
      {{ tabItem.label }}
    </a>
  }
</ng-template>

<ng-template #disabledNavigationItem let-tabItem="tabItem">
  <span class="sh-tab-navigation__item--disabled">{{ tabItem.label }}</span>
</ng-template>
